import styled from 'styled-components';
import { Calendar } from 'react-multi-date-picker';

interface CalendarProps {
  $error?: string;
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CalendarPicker = styled(Calendar)<CalendarProps>`
  border: none;
  background-color: transparent;
  .rmdp-calendar {
    background-color: ${({ theme }) => theme.hover};
    border-radius: 1rem;
    border: 1px solid
      ${({ $error, theme }) => ($error ? theme.error : 'transparent')};
    transition: border 0.3s ease;
  }
`;

export const Info = styled.div`
  caret-color: transparent;
  display: flex;
`;
export const ErrorMessage = styled.span`
  margin-top: 1.5px;
  align-self: flex-start;
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  font-size: 0.75rem;
  color: ${props => props.theme.error};
`;
